import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MktCommonModule } from 'src/app/common/mkt-common.module';

@Component({
  selector: 'app-pdp-stacked-swipe-zone',
  templateUrl: './pdp-stacked-swipe-zone.component.html',
  styleUrl: './pdp-stacked-swipe-zone.component.scss',
  standalone: true,
  imports: [MktCommonModule]
})
export class PdpStackedSwipeZoneComponent implements OnChanges {
  @Input() headerContent!: any;
  @Input() stackedZoneDisplayFlags!: any;
  accordionStatus: any = {};
  @Output() taggingEmit = new EventEmitter<any>();

  ngOnChanges(changes: SimpleChanges): void {
    if(this.headerContent?.mobileStackedSwipeZone){
      [...this.headerContent.mobileStackedSwipeZone].forEach((v,i)=> this.accordionStatus[i] = v.isExpanded);
    }
  }
  onTagging(title: string, index: number): void{
    this.taggingEmit.emit({'page_inter': title, 'show': !this.accordionStatus[index]});
  }
}
